export default __webpack_public_path__ + "static/media/line_blood.35b71723.png";